import React, { PureComponent, ReactElement } from 'react';

import { Accordion, Link, Loader, Text } from '@philips-emr/tws-components/lib/components';
import { Size } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { arrayOf, object, string } from '@philips-emr/tws-core/lib/component/prop-types';

enum Type {
  ACCORDION = 'ACCORDION',
}

interface HpmsDynamicScreenProps {
  data: Dynamic[];
  uuid: string,
}

interface Dynamic {
  data: Dynamic[];
  label: string;
  link: string;
  type: string;
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
export default class HpmsDynamicScreen extends PureComponent<HpmsDynamicScreenProps> {

  static propTypes = {
    data: arrayOf(object).notEnumerable(),
    uuid: string,
  };

  render(): ReactElement | null {
    const { data } = this.props;

    if (!data) {
      return <div style={{ padding: '7.5rem' }}><Loader size={64} /></div>;
    }

    return this.mount(data);
  }

  mount(data: Dynamic[]): ReactElement | null {
    if (!data) {
      return null;
    }

    return (<div className={'c-hpms-dynamic-screen'}>{
      data.map(item => {
        if (item.type === Type.ACCORDION) {
          return this.getAccordion(item.label, this.mount(item.data));
        } else {
          return this.getLink(item.label, item.link);
        }
      })
    }</div>);
  }

  getAccordion(value: string, content: ReactElement | null): ReactElement | null {
    const { uuid } = this.props;

    return (
      <Accordion uuid={uuid} initialCollapsed={false}>
        <div slot={'header'}><Text value={value} size={Size.MEDIUM} ></Text></div>
        <div slot={'content'} style={{ width: '100%' }}>{content}</div>
      </Accordion>
    );
  }

  getLink(value: string, link: string): ReactElement | null {
    return (<div style={{ padding: '5px' }}>
      <Link onClick={() => window.open(link)} value={value} size={Size.MEDIUM}></Link>
    </div>);
  }
}
